import React from 'react';
import PropTypes, { arrayOf } from 'prop-types';
import { Form } from 'react-bootstrap';

const RoleCheckboxFilter = ({
  name,
  setFilter,
  customOptions,
  withCaption = false,
  className,
  wrapperStyle,
}) => {
  const initialValues = customOptions
    .filter(option => option.defaultChecked)
    .map(option => option.value);
  const [selectedValues, setSelectedValues] = React.useState(initialValues);

  const handleCheckboxChange = (value, isChecked) => {
    let updatedValues = [...selectedValues];
    if (isChecked) {
      updatedValues = [...updatedValues, value];
    } else {
      updatedValues = updatedValues.filter(val => val !== value);
    }
    setSelectedValues(updatedValues);

    const filterParams = {};

    const includesManager = updatedValues.includes('Manager');
    const includesOwner = updatedValues.includes('Owner');
    const includesArtist = updatedValues.includes('Artist');

    if (includesManager) {
      filterParams.manager = true;
    }
    if (includesOwner) {
      filterParams.owner = true;
    }

    if (includesArtist) {
      filterParams.artist = true;
    }

    if (updatedValues.length) {
      setFilter('manager', filterParams.manager !== undefined ? filterParams.manager : undefined);
      setFilter('owner', filterParams.owner !== undefined ? filterParams.owner : undefined);
      setFilter('artist', filterParams.artist !== undefined ? filterParams.artist : undefined);
    } else {
      setFilter('manager', undefined);
      setFilter('owner', undefined);
      setFilter('artist', undefined);
    }
  };

  return (
    <Form.Group style={wrapperStyle} className={`d-flex flex-column ${className}`}>
      {withCaption && <Form.Label style={{ textTransform: 'capitalize' }}>{name}</Form.Label>}
      {customOptions.map(option => (
        <Form.Check
          key={option.value}
          type="checkbox"
          label={option.label}
          checked={selectedValues.includes(option.value)}
          onChange={e => handleCheckboxChange(option.value, e.target.checked)}
        />
      ))}
    </Form.Group>
  );
};

RoleCheckboxFilter.propTypes = {
  name: PropTypes.string,
  setFilter: PropTypes.func.isRequired,
  customOptions: arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      value: PropTypes.string.isRequired,
      defaultChecked: PropTypes.bool,
    }),
  ).isRequired,
  withCaption: PropTypes.bool,
  className: PropTypes.string,
  wrapperStyle: PropTypes.object,
};

export default RoleCheckboxFilter;
